<div>
    <!--<button class="btn  primary-color-bg" (click)="clicked()">Apply!</button>-->
    <a class="c-button primary-color-bg detail-colors" href="javascript:void(0)" (click)="clicked()">
        <span>Apply</span>
        <span class="c-icon c-icon--main">
            <span *ngIf="(!showLoader && !showError)"><i class="fa fa-check tick-icon" aria-hidden="true" ></i></span>
            <div class="loading-spinner" *ngIf="(showLoader && !showError)"></div>
            <span id="validation" *ngIf="showError" tooltip="There is no data available for the advertiser and/or dates you've selected.
            Please select an advertiser and/or a different set of dates." placement="bottom">
                <i class="fa fa-exclamation error-icon" aria-hidden="true"></i>
            </span>
        </span>
    </a>
</div>

